module.exports = __webpack_public_path__ + "static/img/famousKingLogo.a099db1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/famousKingLogo.jpg
// module id = 55
// module chunks = 0